export default "images/标志牌增强显示.png";